import React, { useContext, useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'
import { FiChevronDown, FiTag } from 'react-icons/fi'
import { FaQrcode } from 'react-icons/fa'
import QRCode from 'react-qr-code'

import Dados from '../Dashboard/Prontuario/Dados'
import { api, authHeaders } from '../../../services/api'
import { OpcoesImpressaoTagEmergencia } from '../Dashboard/Prontuario'
import Modal from '../../../components/Modal'
import { GlobalContext } from '../../../contexts/GlobalContext'

export default function () {
	const { checkRecurso } = useContext(GlobalContext)

	const { state } = useLocation()

	const [showOpcoesProntuarioDropdown, setShowOpcoesProntuarioDropdown] = useState(false)
	const [showConfirmacaoImpressaoTag, setShowConfirmacaoImpressaoTag] = useState(false)
	const [QRCodeSharedURL, setQRCodeSharedURL] = useState(null)
	const showModelosNeuroatipicoState = useState(false)

	const { data: prontuario, isFetching: isFetchingProntuario, refetch: refetchProntuario } = useQuery({
		queryKey: ['get_prontuario_on_dashboard_2'],
		queryFn: async () => {
			const response = await api.get(`prontuario/${state.membro_id}`, authHeaders())
			return response
		},
		refetchOnWindowFocus: false,
		enabled: !!state?.membro_id
	})

	const { data: tokenData } = useQuery({
		queryKey: ['get-tag-token-emergency-shared'],
		queryFn: async () => {
			const response = await api.get(`prontuario/emergencia/get_token/${state.membro_id}`, authHeaders())
			return response
		}
	})

	const { data: recursos } = useQuery({
		queryKey: ['obter-recursos-prontuario-owner'],
		queryFn: async () => {
			if(prontuario) {
				const response = await api.get(`pessoa/${prontuario.pessoa.id}/recursos`, authHeaders())

				const assinaturaAtiva = response.assinaturas.find(assin => assin.status === 'authorized')

				if(assinaturaAtiva) {
					return assinaturaAtiva.plano.recursos.map(recurso => recurso.identificador)
				}

				return []
			}
		},
		placeholderData: [],
		enabled: !!prontuario
	})

	function generateShareQRCodeURL() {
		const { token } = tokenData
		const urlQRCode = `${process.env.REACT_APP_FRONTEND_URL}/emergencia/${token}/shared`

		setQRCodeSharedURL(urlQRCode)
	}

	useEffect(() => {
		function handleClickAway(e) {
			const dropdown = document.querySelector('#opcoes-prontuario-dropdown')
			const trigger = document.querySelector('#opcoes-prontuario-trigger')

			if (!dropdown) {
				return
			}

			if (!dropdown.contains(e.target) && !trigger.contains(e.target)) {
				setShowOpcoesProntuarioDropdown(false)
			}
		}

		document.addEventListener('click', handleClickAway)

		return () => {
			document.removeEventListener('click', handleClickAway)
		}
	}, [])

	return (
		<div className="my-8 flex flex-col">
			{!!prontuario && (
				<details className="mx-4 mb-6 md:self-end md:w-72 relative" open={showOpcoesProntuarioDropdown}>
					<summary
						id="opcoes-prontuario-trigger"
						onClick={e => {
							e.preventDefault()
							setShowOpcoesProntuarioDropdown(old => !old)
						}}
						className="select-none bg-sky-600 hover:bg-sky-700 p-3 py-5 md:py-3 list-none rounded-md appearance-none cursor-pointer flex justify-between gap-4 items-center shadow-lg transition-all"
					>
						<span>Opções do Prontuário</span>
						<FiChevronDown size={18} />
					</summary>

					<ul id="opcoes-prontuario-dropdown" className="flex flex-col fadeIn animated shadow-md mx-2 absolute z-10 w-[calc(100%-16px)] md:w-[272px]">
						{(checkRecurso('cartao-emergencia') || checkRecurso('inclusao-plano-individual') || recursos.some(r => r.identificador === 'cartao-emergencia')) && (
							<li className="border-b border-b-slate-300">
								{!isFetchingProntuario && (
									<div
										onClick={() => {
											setShowOpcoesProntuarioDropdown(false)

											setShowConfirmacaoImpressaoTag(true)
										}}
										className="text-sky-600 grid grid-cols-[1.6rem_1fr] items-center gap-4 justify-center p-5 w-full cursor-pointer hover:bg-slate-100 bg-white transition-all"
										id="botao-imprimir-tag"
									>
										<FiTag size={18} />
										<span>QRCode de emergência</span>
									</div>
								)}
							</li>
						)}

						<li className="border-b border-b-slate-300">
							{!isFetchingProntuario && (
								<div
									onClick={() => {
										setShowOpcoesProntuarioDropdown(false)

										generateShareQRCodeURL()
									}}
									className="text-sky-600 grid grid-cols-[1.6rem_1fr] items-center gap-4 justify-center p-5 w-full cursor-pointer hover:bg-slate-100 bg-white transition-all"
									id="botao-imprimir-tag"
								>
									<FaQrcode size={18} />
									<span>Compartilhar via QRCode</span>
								</div>
							)}
						</li>
					</ul>
				</details>
			)}

			<Dados
				pessoaId={state.membro_id}
				prontuario={prontuario}
				refetchProntuario={refetchProntuario}
				isFetchingProntuario={isFetchingProntuario}
				tokenData={tokenData}
			/>

			<Modal
				isOpen={showConfirmacaoImpressaoTag}
				handleClose={() => {
					setShowConfirmacaoImpressaoTag(false)
				}}
				title="Confirmação de impressão"
			>
				<OpcoesImpressaoTagEmergencia
					pessoaId={state.membro_id}
					showModelosNeuroatipicoState={showModelosNeuroatipicoState}
					refetchProntuario={refetchProntuario}
				/>
			</Modal>

			<Modal
				isOpen={!!QRCodeSharedURL}
				handleClose={() => {
					setQRCodeSharedURL(null)
				}}
				title="Escaneie o QRCode"
			>
				<div className="flex flex-col gap-4">
					<p className="font-semibold mx-2">
						QRCode de AUTORIZAÇÃO de ACESSO ao Prontuário da Saúde do Cidadão de {prontuario?.pessoa.nome}.
					</p>

					{QRCodeSharedURL && <QRCode value={QRCodeSharedURL} className="w-full object-contain" />}

					<p className="text-center">Escaneie este QRCode com o dispositivo para o qual deseja dar acesso ao seu prontuário.</p>
				</div>
			</Modal>
		</div>
	)
}
